module.exports = __webpack_public_path__ + "assets/img/Edito_Nicolas-Feit_menu.f0366d50-ps.jpg";